export const LayoutConst = {
  searchConditionDrawer: {
    width: 235,
  },
  pageHead: {
    height: 24,
  },
  table: {
    minWidth: {
      default: 890,
    },
  },
  expantionPanel: {
    summary: {
      height: 24,
    },
  },
  virtualFolderTree: {
    group: {
      minHeight: 240,
    },
  },
};

export const UrlConst = {
  auth: {
    login: "/login",
  },
  admin: {
    userConfig: "/admin/config/user_config",
    userGroupConfig: "/admin/config/user_group_config",
    connectionConfig: "/admin/config/connection_config",
    dictionaryConfig: "/admin/config/dictionary_config",
    notification: "/admin/notification",
  },
  member: {
    fullTextSearch: "/full_text_search",
    similarityTextSearch: "/similarity_text_search",
    virtualFolder: "/virtual_folder",
    virtualFolderAdmin: "/virtual_folder_admin",
  },
  self: {
    changePassword: "/self/password_change",
  },
};
